export const vaultAboutContent = {
  top: {
    title: ['The Original', 'Trading Card Vault<sup>&reg;</sup>'],
    body: [
      '<div class="mb-3">The <b>largest</b> and most sophisticated trading card archival service in the world. Built from scratch and designed to provide investors the storage and liquidity options they deserve. Trading cards are becoming the world\'s premier tangible asset, and the Fanatics Vault is the tool at the heart of many of the market\'s most advanced portfolios.</div>',
      'The Vault service is free for life on any trading card valued over $50 or any assets purchased through Fanatics Collect (regardless of value). All other items are charged a nominal one-time fee.'
    ],
    textSide: 'left',
    backgroundColor: 'white',
    imageUrlDesktop: jsConfig.links.imagesUrl + 'vault-gallery.png',
    imageUrlMobile: jsConfig.links.imagesUrl + 'about-vault-card-collage-mobile.png',
    titleType: 'h1',
    overflowImage: true,
    noAssetBackground: true,
    containImage: true,
    bodyIsHTML: true
  },
  middle: {
    title: ['Asset Liquidity, Our #1 Priority'],
    body: [
      'The Vault is a one-stop solution to the market\'s most powerful liquidity options. Trading cards are becoming the world\'s premier tangible asset. Why? Because they are aggressively consumed by a passionate investor base, and because trading cards offer greater liquidity options than any other competitive market. Through the Fanatics Vault, clients have access to Weekly Sunday Auctions, Monthly Premier Auctions, and the Buy Now Marketplace. Private sales through our industry leading sales team are also enabled through Vault Archival. Trading and asset transfers with other Vault clients are another popular liquidity option. And lastly, lending from Fanatics Capital offers collateralized lending against your Vault Portfolio. No other archival service empowers investors\' liquidity needs more than the Fanatics Vault.'
    ],
    textSide: 'right',
    backgroundColor: 'gray',
    imageUrlDesktop: jsConfig.links.imagesUrl + 'about-vault-icons-desktop.png',
    imageUrlMobile: jsConfig.links.imagesUrl + 'about-vault-icons-mobile.png',
    overflowImage: false,
    noAssetBackground: true,
    containImage: false
  },
  main: [
    {
      title: ['Seamless Buying and Selling'],
      body: [
        'The Vault is a powerful tool for both buyers and sellers alike. As a buyer, you can immediately place recent Fanatics Collect purchases into your Portfolio, and purchases from other 3rd parties are easily shipped directly to your Vault, empowering Fanatics Collect staff to verify the assets on your behalf and leveraging the 0% sales tax of the Vault service. As a seller, your Vault Portfolio is a liquidity powerhouse with archived items effortlessly connected to any of our marketplaces. Furthermore, a full-scale logistics team is available to assist with both inbound and outbound shipping needs. The Vault is everything buyers and sellers require to manage a trading card portfolio.'
      ],
      textSide: 'left',
      backgroundColor: 'gray',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-vault-screenshot-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-vault-ss-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true
    },
    {
      title: ['Certified Security & Access'],
      body: [
        'The Fanatics Vault is the only UL rated secure facility in the market. Designed from the ground up for the trading card market and residing at the center of Fanatics Collect headquarters. Assets in the Vault are fully insured, and the facility holds an industry best UL-Class 3 Certification, which is the highest available for any storage facility. Because the Vault resides at the center of our operations, customer service and sales team members have unparalleled access to all items in archival. '
      ],
      textSide: 'right',
      backgroundColor: 'white',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-vault-vault-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-vault-vault-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true
    },
  ]
};

export const vaultFees = {
  title: 'One-Time Vault Processing Fees',
  bodyText: [
    '<b>1% fulfillment fee</b> applies to any asset which is fulfilled out of the Fanatics Vault.',
    '<b>This fee is increased to 3%</b> if the asset is removed within 90 days of archival.'
  ],
  sections: [
    {
      title: 'Authenticated Trading Cards',
      image: jsConfig.links.imagesUrl + 'vault/vault-rates-auth-cards.png',
      price: 'FREE VAULT<sup class="text-warning">*</sup>',
      paragraphs: [
        {
          classes: 'text-corduroy font-weight-bold',
          content: 'Free for any card, ticket or other standard-size slab with a market value of $50 or greater.'
        },
        {
          classes: 'text-warning',
          content: '*Just a $3, one-time fee for items less than $50. Assets submitted to Auction or sold in 30 days are always free, regardless of value.'
        }
      ]
    },
    {
      title: 'Non-Authenticated (Raw) Trading Cards',
      image: jsConfig.links.imagesUrl + 'vault/vault-rates-raw.png',
      price: '$3 or $6',
      paragraphs: [
        {
          classes: 'text-corduroy font-weight-bold',
          content: 'Raw cards, any value or genre accepted. All raw cards receive priority MBA Authentication and can be sold on any Fanatics Collect Marketplace.'
        },
        {
          classes: 'text-warning',
          content: '$3 if submitted to Auction or sold within 30 days. $6 if archived in the Vault.'
        },
      ]
    },
    {
      title: 'Oversized Slabs & Wax',
      image: jsConfig.links.imagesUrl + 'vault/vault-rates-oversized.png',
      price: '$15 FLAT FEE',
      paragraphs: [
        {
          classes: 'text-corduroy font-weight-bold',
          content: 'Comics, video games, photos, balls, approved smaller memorabilia, smaller factory original wax, and other oversized slabbed items.'
        },
      ]
    },
    {
      title: 'Larger Items',
      image: jsConfig.links.imagesUrl + 'vault/vault-rates-large.png',
      price: '$25 FLAT FEE',
      paragraphs: [
        {
          classes: 'text-corduroy font-weight-bold',
          content: 'Larger wax & cases, approved sneakers, jerseys, and other large items.'
        },
        {
          classes: 'text-warning',
          content: 'All larger items must be pre-approved.'
        }
      ]
    },
    {
      title: 'Fanatics Collect Purchases',
      image: jsConfig.links.imagesUrl + 'vault/vault-rates-pwcc-purchases.png',
      price: 'FREE VAULT FOR LIFE!',
      classes: 'last',
      paragraphs: [
        {
          classes: 'text-corduroy font-weight-bold',
          content: 'Free shipping, Oregon 0% sales tax, and free archival on any item purchased from Fanatics Collect and shipped to your Vault.'
        },
      ]
    },
  ]
};
